<div class="mx-5" *ngIf="sharedDataSvc.allListsLoaded">

    <button class="btn btn-sm btn-primary my-2" type="button" (click)="toggleDisplayFilters()">
        <span *ngIf="!visibleFilters">
            <paflabel lblCod="Filtres_de_recherche"></paflabel>&nbsp;<i class="fas fa-search"></i>
        </span>
        <span *ngIf="visibleFilters">
            <paflabel lblCod="Masquer_les_filtres"></paflabel>&nbsp;<i class="far fa-caret-square-up"></i>
        </span>
    </button>
    <div class="card bg-light shadow-sm" [hidden]="!visibleFilters">
        <div class="card-body">
            <form>
                <div class="row">
                    <div class="col">
                        <div class="mb-1">
                            <label class="control-label" paflabel="Nom_du_fournisseur"></label> (<small><label
                                    paflabel="Contient"></label></small>)
                            <input type="text" class="form-control" name="SupplierName"
                                [(ngModel)]="filters.SupplierName">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-1">
                            <label class="control-label" paflabel="Numero_d_identification"></label>(<small><label
                                paflabel="Contient"></label></small>)
                            <input type="text" class="form-control" name="UniqueId" [(ngModel)]="filters.UniqueId">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-1">
                            <label class="control-label" paflabel="NumTiers"></label>
                            <input type="text" class="form-control" name="NumTiers" [(ngModel)]="filters.NumTiers">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-1">
                            <label class="control-label" paflabel="Statut"></label>
                            <kendo-multiselect class="form-control" name="Statuts" [data]="lstStatuts"
                                [(ngModel)]="filters.Statuts" [textField]="'LblCod'" [valueField]="'Id'">
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <supplier-statut-badge [supplierStatutId]="dataItem.Id">
                                    </supplier-statut-badge>
                                  </ng-template>
                                  <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    <supplier-statut-badge [supplierStatutId]="dataItem.Id">
                                    </supplier-statut-badge>
                                  </ng-template>
                            </kendo-multiselect>
                            
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2">
                        <div class="mb-1">
                            <label class="control-label" paflabel="Nom_du_groupe"></label>
                            <input type="text" class="form-control" name="GroupName"
                                [(ngModel)]="filters.GroupName">
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="mb-1">
                            <label class="control-label" paflabel="Nom_du_contact_ENDEL"></label>
                            <input type="text" class="form-control" name="InternalContactLastname"
                                [(ngModel)]="filters.InternalContactLastname">
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="mb-1">
                            <paf-combobox 
                                headerPafLabel="Pays"
                                [(ngModel)]="filters.CountryId"  
                                [bindToId]="true"
                                name="country" 
                                [data]="sharedDataSvc.countries">
                            </paf-combobox>
                        </div>
                    </div>
                    <div class="col-5" *ngIf="showDepartments">
                            <departments [multiple]="true"
                                [(regionIds)]="filters.RegionIds" 
                                [(departmentIds)]="filters.DepartmentIds"></departments>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <button class="btn btn-primary mx-2" type="commit" (click)="search()"><i
                                class="fas fa-search"></i> Rechercher</button>
                                <!-- <button class="btn btn-success mx-2" type="button" (click)="exportToExcel(grid)"><i class="far fa-file-excel" ></i>Exporter</button> -->
                                <button class="btn btn-success mx-2" type="button" (click)="excelexport.save()"><i class="far fa-file-excel" ></i>Exporter</button>
                        <button class="btn btn-danger mx-2" type="button" (click)="reinit()"><i class="fas fa-ban"></i>Réinitialiser</button>
                    </div>
                </div>
            </form>
            <pre *ngIf="sharedDataSvc.debug">
                {{filters | json}}
            </pre>
        </div>
    </div>

    <div class="card mt-3 shadow-sm">
        <div class="card-body" ID="suppplierListContainer">
            <kendo-grid #grid [data]="gridData" [pageSize]="state.take" [skip]="state.skip" [sort]="state.sort"
                [filter]="state.filter" [sortable]="true" [pageable]="{pageSizes: [10,20,50,100]}" [filterable]="'menu'"
                (cellClick)="editSupplier($event)" (dataStateChange)="dataStateChange($event)">
                <kendo-grid-messages filterIsFalse="Non&nbsp;&nbsp;" filterIsTrue="Oui&nbsp;&nbsp;">
                </kendo-grid-messages> 
                <kendo-grid-column *ngIf="sharedDataSvc.debug" field="Id" Title="Id" [width]="70">
                </kendo-grid-column>
                <kendo-grid-column field="SupplierName" [width]="300">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Nom_du_fournisseur"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="uniqueIdValue" [width]="180">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Numero_d_identification"></div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <div class="d-flex align-items-start">
                            <div style="width:60px;">
                                <paflabel [lblCod]="dataItem.FunctionalId"></paflabel>
                            </div> 
                            <div class="ml-1">{{dataItem.uniqueIdValue}}</div>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="NumTiers" title="NumTiers" [width]="150">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="NumTiers"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="City" title="Ville" [width]="250">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Ville"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="isHQ" title="Siege" [width]="90"  filter="boolean">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Siege"></div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.isHQ)"></i></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="StatutId" [width]="230">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Statut"></div>
                    </ng-template>
                    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                    <div style="width:100%;">
                        <kendo-multiselect class="filter-multi-select form-control" name="filterStatuts"
                            [data]="lstStatuts" textField="LblCod" valueField="Id" [valuePrimitive]="true"
                            [value]="state.filter | filterValues"
                            (valueChange)="gridFiltersChange($event, filterService,column)">
                            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                <supplier-statut-badge [supplierStatutId]="dataItem.Id">
                                </supplier-statut-badge>
                            </ng-template>
                            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                <supplier-statut-badge [supplierStatutId]="dataItem.Id">
                                </supplier-statut-badge>
                            </ng-template>
                        </kendo-multiselect>
                    </div>
                </ng-template>

                    <ng-template kendoGridCellTemplate let-dataItem>
                        <supplier-statut-badge [supplierStatutId]="dataItem.StatutId"></supplier-statut-badge>
                        <!-- <div paflabel="{{dataItem.LblStatutCod}}"></div> -->
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column *ngIf="columnKillAllowed"  [width]="30" [filterable]="false" [sortable]="false">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <btn-delete-supplier [supplierId]="dataItem.Id"></btn-delete-supplier>
                    </ng-template>
                </kendo-grid-column>
                <!-- <kendo-grid-excel [fileName]="excelExportFileName" [fetchData]="allData"></kendo-grid-excel> -->
            </kendo-grid>

            <kendo-excelexport [data]="excelDatas" [fileName]="excelExportFileName" #excelexport>
                <kendo-excelexport-column field="SupplierName" [title]="sharedDataSvc.getLabel('Nom_du_fournisseur') | async"></kendo-excelexport-column>
                <kendo-excelexport-column field="UniqueNum" [title]="sharedDataSvc.getLabel('Numero_d_identification') | async"></kendo-excelexport-column>
                <kendo-excelexport-column field="NumTiers" [title]="sharedDataSvc.getLabel('NumTiers') | async"></kendo-excelexport-column>
                <kendo-excelexport-column field="City" [title]="sharedDataSvc.getLabel('Ville') | async"></kendo-excelexport-column>
                <kendo-excelexport-column field="HQSiret" [title]="sharedDataSvc.getLabel('Siege') | async">
                    <ng-template let-dataItem>
                        <span>{{isSiegeDisplay(dataItem)}}</span>
                    </ng-template>
                </kendo-excelexport-column>
                <kendo-excelexport-column field="LblStatutCod" [title]="sharedDataSvc.getLabel('Statut') | async"></kendo-excelexport-column>

                <kendo-excelexport-column field="DateStatut" [width]="80" [cellOptions]="{format:'dd/mm/yyyy'}" title="Date"></kendo-excelexport-column>
                <kendo-excelexport-column field="SuspMotif"  title="Raison"></kendo-excelexport-column>
                <kendo-excelexport-column field="ReferentInterne"  title="Référent interne"></kendo-excelexport-column>
                
            </kendo-excelexport>
        </div>
    </div>


</div>